/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RenewalNotificationDto = {
    id: string;
    type: RenewalNotificationDto.type;
    sentAt: string;
    status: string;
    errorMsg?: string | null;
    deliveryStatus?: RenewalNotificationDto.deliveryStatus | null;
    deliveryStatusCode?: string | null;
    deliveryUpdatedAt?: string | null;
    providerMessageId?: string | null;
};
export namespace RenewalNotificationDto {
    export enum type {
        INTERNAL_MANUAL_ALERT = 'INTERNAL_MANUAL_ALERT',
        CLIENT_EMAIL_20_DAY = 'CLIENT_EMAIL_20_DAY',
        CLIENT_SMS_20_DAY = 'CLIENT_SMS_20_DAY',
        CLIENT_EMAIL_7_DAY = 'CLIENT_EMAIL_7_DAY',
        CLIENT_SMS_7_DAY = 'CLIENT_SMS_7_DAY',
        CLIENT_SMS_DAY_BEFORE = 'CLIENT_SMS_DAY_BEFORE',
        CLIENT_EMAIL_DAY_OF_UNPAID = 'CLIENT_EMAIL_DAY_OF_UNPAID',
        CLIENT_EMAIL_DAY_OF_PAID = 'CLIENT_EMAIL_DAY_OF_PAID',
        ADVISER_EMAIL_DAY_OF_UNRENEWED = 'ADVISER_EMAIL_DAY_OF_UNRENEWED',
    }
    export enum deliveryStatus {
        ENROUTE = 'ENROUTE',
        SUBMITTED = 'SUBMITTED',
        DELIVERED = 'DELIVERED',
        EXPIRED = 'EXPIRED',
        REJECTED = 'REJECTED',
        FAILED = 'FAILED',
    }
}

